<script>
export default {
  name: "nav",
  data() {
    return {
      permissionList: [],
      sidebar: {
        _name: "CSidebarNav",
        _children: [
          {
            permissionId: 1,
            _name: "CSidebarNavItem",
            name: `FLOW BUILDER`,
            to: "/flow-builder",
            icon: "cil-settings",
          },
          {
            permissionId: 2,
            _name: "CSidebarNavDropdown",
            name: `BOT ANALYSIS`,
            icon: "cil-bar-chart",
            _children: [
              {
                permissionId: 17,
                _name: "CSidebarNavItem",
                name: `OVERVIEW`,
                to: "/overview",
              },
              {
                permissionId: 18,
                _name: "CSidebarNavItem",
                name: `IN CONVERSATION`,
                to: "/in-conversation",
              },
              {
                permissionId: 31,
                _name: "CSidebarNavItem",
                name: `PRODUCTIVITY REPORT`,
                to: "/productivity-report",
              },
            ],
          },
          {
            permissionId: 3,
            _name: "CSidebarNavItem",
            name: `MESSAGE LOG`,
            to: "/message-log",
            icon: "cil-list",
          },
          {
            permissionId: 4,
            _name: "CSidebarNavItem",
            name: `IMAGE MAP`,
            to: "/image-map",
            icon: "cil-image",
          },
          {
            permissionId: 5,
            _name: "CSidebarNavItem",
            name: `SENTIMENT TRAINING`,
            to: "/sentiment-training",
            icon: "cil-comment-bubble",
          },
          {
            permissionId: 6,
            _name: "CSidebarNavItem",
            name: `FLOW WAY TRAINING`,
            to: "/flowway-training",
            icon: "cil-comment-bubble",
          },
          {
            permissionId: 7,
            _name: "CSidebarNavItem",
            name: `SETTING TIME`,
            to: "/setting-time",
            icon: "cil-settings",
          },
          // {
          //   permissionId: 6,
          //   _name: "CSidebarNavItem",
          //   name: `EMAIL CONFIG`,
          //   to: "/email-config",
          //   icon: "cil-settings",
          // },
          // {
          //   permissionId: 5,
          //   _name: "CSidebarNavItem",
          //   name: `SETTING WIDGET`,
          //   to: "/setting-widget",
          //   icon: "cil-settings",
          // },
          {
            permissionId: 8,
            _name: "CSidebarNavItem",
            name: `USER`,
            to: "/user",
            icon: "cil-user",
          },
          {
            permissionId: 9,
            _name: "CSidebarNavItem",
            name: `LIVE`,
            to: "/live",
            icon: "cil-user",
          },
          {
            permissionId: 37,
            _name: "CSidebarNavDropdown",
            name: `CSAT`,
            icon: "cil-group",
            _children: [
              {
                permissionId: 37,
                _name: "CSidebarNavItem",
                name: `FORM SETTING`,
                to: "/csat/form-setting",
              },
              {
                permissionId: 37,
                _name: "CSidebarNavItem",
                name: `CHANNEL SETTING`,
                to: "/csat/channel-setting",
              },
            ],
          },
          {
            permissionId: 10,
            _name: "CSidebarNavDropdown",
            name: `SETTING`,
            icon: "cil-settings",
            _children: [
              {
                permissionId: 29,
                _name: "CSidebarNavItem",
                name: `SETTING`,
                to: "/setting",
              },
              {
                permissionId: 19,
                _name: "CSidebarNavItem",
                name: `SETTING BRAND`,
                to: "/setting-brand",
              },
              {
                permissionId: 36,
                _name: "CSidebarNavItem",
                name: `ASSIGN BY TEAM`,
                to: "/assign-by-team",
              },
              {
                permissionId: 20,
                _name: "CSidebarNavItem",
                name: `SETTING CONFIG`,
                to: "/setting-config",
              },
              {
                permissionId: 21,
                _name: "CSidebarNavItem",
                name: `PLUGIN`,
                to: "/setting-plugin",
              },
              {
                permissionId: 22,
                _name: "CSidebarNavItem",
                name: `WAIT TIME`,
                to: "/wait-time",
              },
              {
                permissionId: 23,
                _name: "CSidebarNavItem",
                name: `RESOLUTION TIME`,
                to: "/resolution-time",
              },
              {
                permissionId: 24,
                _name: "CSidebarNavItem",
                name: `CONVERSATION TOPIC`,
                to: "/conversation-topic",
              },
              {
                permissionId: 25,
                _name: "CSidebarNavItem",
                name: `CHAT SETTING`,
                to: "/setting-chat",
              },
              {
                permissionId: 26,
                _name: "CSidebarNavItem",
                name: `EMAIL TEMPLATE`,
                to: "/email-template",
              },
              {
                permissionId: 27,
                _name: "CSidebarNavItem",
                name: `ROLE`,
                to: "/setting-role",
              },
              {
                permissionId: 28,
                _name: "CSidebarNavItem",
                name: `SLA POLICY`,
                to: "/setting-sla-policy",
              },
              {
                permissionId: 32,
                _name: "CSidebarNavItem",
                name: `SCORE SETTING`,
                to: "/setting-score",
              },
              {
                permissionId: 33,
                _name: "CSidebarNavItem",
                name: `WORD ACCURACY`,
                to: "/setting-word/accuracy",
              },
              {
                permissionId: 34,
                _name: "CSidebarNavItem",
                name: `NEGATIVE WORD`,
                to: "/setting-word/negative",
              },
              {
                permissionId: 35,
                _name: "CSidebarNavItem",
                name: `END THE CONVERSATION`,
                to: "/setting-word/end-the-conversation",
              },
              // {
              //   permissionId: 30,
              //   _name: "CSidebarNavItem",
              //   name: `WHATSAPP TEMPLATE`,
              //   to: "/whatsapp-template",
              // },
            ],
          },
          {
            permissionId: 11,
            _name: "CSidebarNavItem",
            name: `TEAM`,
            to: "/team",
            icon: "cil-user",
          },
          {
            permissionId: 12,
            _name: "CSidebarNavItem",
            name: `API TRIGGER`,
            to: "/api-trigger",
            icon: "cil-settings",
          },
          {
            permissionId: 13,
            _name: "CSidebarNavItem",
            name: `WEBHOOK`,
            to: "/webhook",
            icon: "cil-settings",
          },
          {
            permissionId: 14,
            _name: "CSidebarNavItem",
            name: `VARIABLE`,
            to: "/variable",
            icon: "cil-settings",
          },
          {
            permissionId: 15,
            _name: "CSidebarNavItem",
            name: `CUSTOMER`,
            to: "/customer",
            icon: "cil-user",
          },
          {
            permissionId: 16,
            _name: "CSidebarNavItem",
            name: `CHAT`,
            to: "/chat",
            icon: "cil-comment-bubble",
          },
        ],
      },
    };
  },
  created: async function () {
    await this.getPermissionList();
  },
  computed: {
    sidebarItems() {
      if (!this.permissionList.length) return [];
      return [
        {
          _name: "CSidebarNav",
          _children: this.filterMenuByPermission(this.sidebar._children),
        },
      ];
    },
  },
  methods: {
    getPermissionList: async function () {
      await this.axios
        .get(`${this.$baseUrl}/permission/get-permission-ids`)
        .then(async (data) => {
          if (data.result === 1) {
            this.permissionList = data.detail.permission;
            this.$cookies.set(
              `${process.env.VUE_APP_MODE}-admin-permissions`,
              this.permissionList,
              60 * 60 * 24 * 30
            );
            await this.$store.dispatch("setPermission", this.permissionList);
          }
        });
    },
    filterMenuByPermission(list) {
      var menus = this.filterPermission(list);
      menus.forEach((element) => {
        if (element._children) {
          element._children = this.filterPermission(element._children);
          element._children.forEach((element2) => {
            if (element2._children) {
              element2._children = this.filterPermission(element2._children);
            }
          });
        }
      });

      return menus;
    },
    filterPermission(list) {
      var t = list.filter((item) => {
        return this.permissionList.indexOf(item.permissionId) > -1;
      });
      return t;
    },
  },
};
</script>
